import React from "react";
import { Modal } from "../../../../../../../../shared/Modal/Modal";

export function MemberPriceInfoLabel({ children }) {
  const [showInfo, setShowInfo] = React.useState(false);

  return (
    <>
      {children}
      <button
        onClick={() => setShowInfo(true)}
        className="infoIcon absolute -m-t-5 m-l-3 btn-reset"
      >
        {" "}
        <i className="fa fa-info-circle"></i>
      </button>
      {showInfo && (
        <Modal isOpen onClose={() => setShowInfo(false)}>
          <ul>
            <li>
              If <b>Membership Pricing = 0</b>, then $0 will be charged at
              checkout.
            </li>
            <br />
            <li>
              If <b>Membership Pricing</b> is left blank (--):
              <ul style={{ paddingLeft: "20px" }}>
                <li>
                  The system will use <b>Regular Pricing.</b>
                </li>
                <li>
                  If there is a <b>*pre-configured membership discount</b>, it
                  will be applied to the regular price.
                </li>
              </ul>
            </li>
            <br />
            <li>
              If a client has <b>multiple memberships</b>, the system will apply
              the <b>lowest final price</b> — determined by the{" "}
              <b>lowest Membership Pricing</b> or the highest applicable
              discount.
            </li>
            <br />
            <li>
              If there is no <b>*pre-configured discount</b>, the system will
              apply the <b>Membership Pricing</b> (if set); otherwise, it
              defaults to <b>Regular Pricing</b>.
            </li>
          </ul>
          <br />
          <div>
            <i>
              *pre-configured discounts can be adjusted under{" "}
              <b>{`Settings > POS >
              Patient/Client Loyalty`}</b>
            </i>
          </div>
        </Modal>
      )}
    </>
  );
}
